import React from "react";
import {MenuItemCombination} from "../../@types/stores/menu";
import {getAllergenById, getHost, getNextPackageArticleOptionsUrl} from "../../helpers/ApiHelper";
import defaultImg from "../../assets/images/default.webp";
import "./style.scss";
import CombinationStep from "../CombinationStep";
import useLayoutStyles from "../../hooks/styles";
import {useNavigate, useParams} from "react-router";
import {useTranslation} from "react-i18next";
import {moveToTop} from "../../helpers/DomHelper";

export interface CombinationItemProps {
    menuId?: number;
    subMenuId?: number;
    item: MenuItemCombination;
    stepId: number;
}

const CombinationItem = ({item, stepId, menuId, subMenuId}: CombinationItemProps) => {
    const [t] = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const styles = useLayoutStyles();

    // in a package all articles are already selected -> ask only for their modifiers / addons / ingredients
    const goNextPackage = () => {
        moveToTop();

        if (params.change === "change") {
            navigate(`/menu/combination/info`);
            return;
        }

        navigate(getNextPackageArticleOptionsUrl(menuId || -1, subMenuId || -1, item));
    }

    return <div className="CombinationItem">
        <h2>{item.name}</h2>
        <div className="img" style={{backgroundImage: `url(${item.previewEdit ? `${getHost()}${item.previewEdit}` : (styles?.article.defaultEditImage ? `${getHost()}${styles.article.defaultEditImage}` : defaultImg)}`}} />
        <div className="description">{item.description || ""}</div>
        <div className="allergens">
            {item.allergens?.map(allergenId => getAllergenById(allergenId)?.name || null).filter(name => !!name).map(name => <div key={name} className="allergen">{name}</div>)}
        </div>
        {
            item.isPackage
                ? <>
                    {item.combination.map(x => <CombinationStep key={`combinationStep_${x.id}`} item={item} step={x} menuId={menuId || -1} subMenuId={subMenuId || -1} isPackage={true} />)}
                    <div className="buttons">
                        <div className="button dark" onClick={goNextPackage}>{t(`next`)}</div>
                    </div>
                </>
                : item.combination.filter(x => x.id === stepId).map(x => <CombinationStep key={`combinationStep_${x.id}`} item={item} step={x} menuId={menuId || -1} subMenuId={subMenuId || -1} />)
        }
    </div>
}

export default CombinationItem;
